import { BrowserRouter as Router, Routes, Route  } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Home from './pages/Home';
import About from './pages/About';
import Management from './pages/Management';
import ManagedServices from './pages/ManagedServices';
import Services from './pages/Services';
import Infrastructure from './pages/Infrastructure';
import Business from './pages/Business';
import Erp from './pages/Erp.jsx';
import Sap from './pages/Sap';
import Erpsupportmodels from './pages/Erpsupportmodels.jsx';
import Endusertraining from './pages/Endusertraining.jsx';
import Changemanagement from './pages/Changemanagement.jsx';
import Sapsecurityaudit from './pages/Sapsecurityaudit.jsx';
import Dataintegration from './pages/Dataintegration.jsx';
import Datamigration from './pages/Datamigration.jsx';
import Sapextention from './pages/Sapextention.jsx';
import Soc2 from './pages/Soc2.jsx'

import Valuerealization from './pages/Valuerealization.jsx';

import Reengineer from './pages/Reengineer.jsx';
import Oraclesolutions from './pages/Oraclesolutions';
import Cyber from './pages/Cyber';
import Micro from './pages/Micro';
import It from './pages/It';
import Solutions from './pages/Solutions';
import CaseStudies from './pages/CaseStudies';
import DataCenters from './pages/DataCenters.jsx';
import Private5G from './pages/Private5G.jsx';
import IndustrialAR from './pages/IndustrialAR.jsx';

import ERPCaseStudies from './pages/ERPCaseStudies';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import Header from './components/Header';
import SmartSurveillance from "./pages/SmartSurveillance.jsx";

// import Footer from './components/Footer';

function App() {
    return (
      <div className="App">
        <Router>
        <ScrollToTop /> 
          <Header/>
         <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/management" element={<Management />} />
            <Route path="/managed-services" element={<ManagedServices />} />
            <Route path="/services" element={<Services />} />
            <Route path="/infrastructure" element={<Infrastructure />} />
            <Route path="/Business" element={<Business />} />
            <Route path="/Erp" element={<Erp />} />
            <Route path="/Sap" element={<Sap />} />
            <Route path="/Erpsupportmodels" element={<Erpsupportmodels />} />
            <Route path="/Endusertraining" element={<Endusertraining />} />
            <Route path="/Changemanagement" element={<Changemanagement />} />
            <Route path="/Sapsecurityaudit" element={<Sapsecurityaudit />} />
            <Route path="/Dataintegration" element={<Dataintegration />} />
             <Route path="/Datamigration" element={<Datamigration />} />
             <Route path="/Sapextention" element={<Sapextention />} />
             <Route path="/Valuerealization" element={<Valuerealization />} />
             <Route path="/Reengineer" element={<Reengineer />} />
            <Route path="/Oraclesolutions" element={<Oraclesolutions />} />
            <Route path="/Cyber" element={<Cyber />} />
            
            <Route path="/Micro" element={<Micro />} />
            <Route path="/Soc2" element={<Soc2 />} />
            <Route path="/It" element={<It />} />
            <Route path="/Solutions" element={<Solutions />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/DataCenters" element={<DataCenters />} />
            <Route path="/Private5G" element={<Private5G />} />
            <Route path="/IndustrialAR" element={<IndustrialAR />} />
            <Route path="/SmartSurveillance" element={<SmartSurveillance />} />
            <Route path="/erp-case-studies" element={<ERPCaseStudies />} />
            <Route path="/Careers" element={<Careers />} />
            <Route path="/Contact" element={<Contact />} />
         </Routes>
         {/* <Footer/> */}
        </Router>
      </div>
    );
}

export default App;

